module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_0@3x.99170b50.png";